import { render, staticRenderFns } from "./Riskdefinitiontable.vue?vue&type=template&id=388e736e"
import script from "./Riskdefinitiontable.vue?vue&type=script&lang=js"
export * from "./Riskdefinitiontable.vue?vue&type=script&lang=js"
import style0 from "./Riskdefinitiontable.vue?vue&type=style&index=0&id=388e736e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports